module.exports = __webpack_public_path__ + "media/invest/hero-c4137eb6.jpg";